module.exports = __webpack_public_path__ + "static/media/xtra-pink.cfd1f031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/xtra-pink.jpg
// module id = 88
// module chunks = 0